/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Button } from 'antd';

const primary = {
  backgroundColor: '#5564F8',
  borderColor: '#5564F8',
  borderRadius: '20px',
  boxShadow: 'none',
  color: 'white',
  height: '45px',
  marginLeft: '16px',
  textShadow: 'none'
};

const secondary = {
  backgroundColor: 'white',
  borderColor: '#5564F8',
  borderRadius: '20px',
  boxShadow: 'none',
  color: '#5564F8',
  height: '45px',
  marginLeft: '16px',
  textShadow: 'none'
};

const edit = {
  backgroundColor: 'white',
  borderColor: '#CAD8FF',
  borderRadius: '14px',
  boxShadow: 'none',
  color: 'black',
  height: '45px',
  textShadow: 'none'
};

const ghost = {
  ':hover': {
    border: 'none'
  },
  background: 'transparent',
  border: 'none !important',
  borderColor: 'transparent !important',
  borderRadius: '8px',
  boxShadow: 'none !important'
};

const cartBtn = {
  background: 'white',
  border: '1px solid #CAD8FF',
  borderRadius: '10px',
  boxShadow: 'none',
  height: '40px',
  width: '94px'
};

const translateButton = {
  backgroundColor: '#5564F8',
  borderColor: '#5564F8',
  borderRadius: '14px',
  boxShadow: 'none',
  color: 'white',
  fontSize: '12px',
  height: '32px',
  marginLeft: '16px'
};

const greenDevBtn = {
  backgroundColor: 'white',
  borderColor: 'green',
  borderRadius: '20px',
  boxShadow: 'none',
  color: 'green',
  height: '45px',
  marginLeft: '16px',
  textShadow: 'none'
};

const yellowDevBtn = {
  backgroundColor: 'white',
  borderColor: '#FFAA33',
  borderRadius: '20px',
  boxShadow: 'none',
  color: '#FFAA33',
  height: '45px',
  marginLeft: '16px',
  textShadow: 'none'
};

const CButton = (props) => {
  const getStyle = () => {
    switch (props.type) {
      case 'primary':
        return primary;
      case 'ghost':
        return ghost;
      case 'edit':
        return edit;
      case 'cartBtn':
        return cartBtn;
      case 'translate':
        return translateButton;
      case 'greenDevBtn':
        return greenDevBtn;
      case 'yellowDevBtn':
        return yellowDevBtn;
      default:
        return secondary;
    }
  };

  return <Button ref={props.cref} style={{ ...getStyle(), ...props.xstyle }} {...props} />;
};

export default CButton;
